import { defineBlocksWithJsonArray } from 'blockly/core';

import { beginnerTimeField, beginnerTimeUnitField } from '../helpers/block-builders.js';

const TIME_STYLE = 'beginner_time_blocks';

/**
 * Beginner Time blocks.
 * Existing `beginner_wait` is unchanged. Duration blocks reuse field_beginner_time.
 */
const timeBlockDefinitions = [
  {
    type: 'beginner_wait_until',
    message0: 'wait until %1',
    args0: [{ type: 'input_value', name: 'CONDITION', check: 'Boolean' }],
    previousStatement: null,
    nextStatement: null,
    style: TIME_STYLE,
    tooltip: 'Pauses until the condition becomes true.',
    helpUrl: '',
  },
  {
    type: 'beginner_current_time',
    message0: 'current time in %1',
    args0: [beginnerTimeUnitField('UNIT')],
    output: 'Number',
    style: TIME_STYLE,
    tooltip: 'The time since the program started, in seconds or milliseconds.',
    helpUrl: '',
  },
  {
    type: 'beginner_reset_timer',
    message0: 'reset timer',
    previousStatement: null,
    nextStatement: null,
    style: TIME_STYLE,
    tooltip: 'Sets the timer back to zero.',
    helpUrl: '',
  },
  {
    type: 'beginner_timer_value',
    message0: 'timer value in %1',
    args0: [beginnerTimeUnitField('UNIT')],
    output: 'Number',
    style: TIME_STYLE,
    tooltip: 'The time since the timer was last reset, in seconds or milliseconds.',
    helpUrl: '',
  },
  {
    type: 'beginner_has_time_passed',
    message0: 'has %1 passed?',
    args0: [beginnerTimeField('DURATION', { value: 1, unit: 'SECONDS' })],
    output: 'Boolean',
    style: TIME_STYLE,
    tooltip: 'True when the chosen time has passed since the timer was reset.',
    helpUrl: '',
  },
  {
    type: 'beginner_every',
    message0: 'every %1 %2',
    args0: [
      beginnerTimeField('DURATION', { value: 1, unit: 'SECONDS' }),
      { type: 'input_statement', name: 'DO' },
    ],
    previousStatement: null,
    nextStatement: null,
    style: TIME_STYLE,
    tooltip: 'Runs the blocks inside again and again at the chosen interval.',
    helpUrl: '',
  },
];

export function registerBeginnerTimeBlocks(): void {
  defineBlocksWithJsonArray(timeBlockDefinitions);
}
